<div class="row">
  <div class="col">
    <h1 class="pb-2">Dr. Blumer & Partner</h1>
    <p class="lead">
      @if (currentLanguage === 'de') {
        Quantitative Modelle im Finanzbereich verwenden mathematische, statistische und computergestützte Methoden, um Entscheidungen zu treffen, Risiken zu managen und Marktchancen zu identifizieren. Sie spielen eine entscheidende Rolle in der modernen Finanzwirtschaft, da sie komplexe Zusammenhänge analysieren und automatisierte Handelsstrategien ermöglichen. Dr. Blumer & Partner AM bietet verschiedene Produkte mit verschiedenen Strategien an um eine möglichst breite Diversifizierung zu erhalten.
      }
      @if (currentLanguage === 'en') {
        Quantitative models in the financial sector use mathematical, statistical and computer-aided methods to make decisions, manage risks and identify market opportunities. They play a crucial role in modern finance as they analyze complex relationships and enable automated trading strategies. Dr. Blumer & Partner AM offers various products with different strategies in order to achieve the broadest possible diversification.
      }
    </p>
  </div>
</div>


@if (categoryData) {
  <div class="row">
    <!-- Loop through each category -->
    @for (category of categoryData; track category; let first = $first) {
      <div class="col col-12 pb-2 pt-4">
        <!-- Display category name -->
        @if (category.translations[currentLanguage]) {
          <h2 class="headline-2">{{ category.translations[currentLanguage].name }}</h2>
        }
      </div>

      @for(product of category.products; track product; let index = $index;){
          <div class="col col-12" [ngClass]="{'col-lg-12': first, 'col-lg-6': !first}">

          <!-- Display product information in a card -->
          <app-cards-basic title="{{ product.product.translations[currentLanguage].title }}">

            @if(product.product.chartData){<!-- Display chart only if chart data is available -->
              <app-charts [productData]="product.product"
                          [chartDataInput]="product.product.chartData"
                          [statisticData]="[{'id': product.product.id.toString() + $index + category.id, 'section': product.product.id.toString() + $index + category.id, 'statistics': [{'id': product.product.id.toString() + $index + category.id, 'statistic_choice': 'performance'}], 'chart': 'line', 'frequency': 'weekly'}]"
                          [isCustomData]="false">
              </app-charts>
            } @else {
              <div style="width: 100%; height: 280px; display: flex; justify-content: center; align-items: center;">
                <mat-spinner diameter="30" strokeWidth="1"></mat-spinner>
              </div>
            }


            @if(product.product.phases[0] && product.product.phases[0].translations[currentLanguage].description){
              <div class="row pt-2 pb-2">
                <div class="col font-regular overline">
                  {{ product.product.phases[0]?.translations[currentLanguage].description }}
                </div>
              </div>
            }



            <div class="row pt-2 pb-2">
              <!-- Last Price -->
              <div class="col">
                <div class="font-regular">{{ 'COMMON.last_price' | translate }}
                  : {{ product.product.last_price?.price }}
                </div>
                <div class="font-regular overline">
                  {{ 'COMMON.as_of' | translate }} {{ product.product.last_price?.date | localizedDate: 'longDate' }}
                </div>
              </div>
              @if (product.product.year_to_date_return?.return) {
                <div class="col">
                  <div class="font-regular">{{ 'COMMON.year_to_date_return' | translate }}
                    : {{ product.product.year_to_date_return?.return }}%
                  </div>
                  <div class="font-regular overline">
                    {{ 'COMMON.as_of' | translate }} {{ product.product.year_to_date_return?.date | localizedDate: 'longDate' }}
                  </div>
                </div>
              }
            </div>

            <!-- Link to Product Details -->
            <a mat-flat-button
               color="primary"
               type="button"
               class="bp-button"
               [routerLink]="['/', 'products', product.product.translations[currentLanguage].slug] | localize">
              {{ 'ACTIONS.view_details' | translate }}
            </a>
          </app-cards-basic>
        </div>

      }

    }
  </div>
}


